import React from 'react';
import { IPaymentDetailsProps } from '@components/Sura/PaymentDetails/types';
import useStyles from '@components/Sura/PaymentDetails/styles';
import { Typography, Divider } from '@material-ui/core';
import { observer } from 'mobx-react';
import useStore from '@hooks/useStore';
import { formattedAmount } from '@utils/format';

const HeaderTotal: React.FC<IPaymentDetailsProps> = () => {
  const { links, ui } = useStore();
  const isUSD = links.paymentLink.exchangeRate === 'USD';
  const css = useStyles({ isMobile: ui.isMobileScreen });

  return (
    <>
      <Typography className={css.total}>
        {formattedAmount(links.paymentLink.total, isUSD ? 'USD' : 'MXN')}
      </Typography>
      {!ui.isMobileScreen && <Divider variant="inset" className={css.divider} />}
      <Typography className={css.labelTotal}>TOTAL A PAGAR {isUSD ? 'USD' : 'MXN'}</Typography>
    </>
  );
};

export default observer(HeaderTotal);
